import RecommendationDashboard from "./src/recommendation-dashboard";

export default RecommendationDashboard;
